const state = {
  commentDetails: [],
};
const getters = {
  commentDetails(state) {
    return state.folderDetails;
  },
};
const mutations = {
  SHOW_DETAILS(state, data) {
    state.folderDetails = data;
  },
};
const actions = {
  async video_comments({ commit }, recordingId) {
    const response = await window.axios.get(
      "/comments/" + recordingId + "/list"
    );
    commit("SHOW_DETAILS", response.data);
    return response;
  },
  async video_public_comments({ commit }, recordingId) {
    const response = await window.axios.get(
      "/comments/" + recordingId + "/get-public-list"
    );
    commit("SHOW_DETAILS", response.data);
    return response;
  },
  async add_public_comment(_, form) {
    const response = await window.axios.post(
      "/comments/" + form.recording_id + "/add-public-comment",
      form
    );
    return response;
  },
  async add_comment(_, form) {
    const response = await window.axios.post(
      "/comments/" + form.recording_id + "/add",
      form
    );
    return response;
  },
  async update_comment(_, form) {
    const response = await window.axios.patch(`/comments/update/${form.id}`, {
      comment: form.comment,
      commented_at: form.commented_at,
    });
    return response;
  },
  async delete_comment(_, form) {
    const response = await window.axios.delete(`/comments/${form.id}/delete`);
    return response;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
